import React, { useEffect, useMemo, useState } from "react";
import { Link, useParams } from "react-router-dom";
import "./OpenProfileLink.css";

const APP_SCHEME = "lutero://u";
const FALLBACK_DELAY_MS = 1600;

function isValidKey(value) {
  return /^[a-zA-Z0-9_.-]{3,80}$/.test(value);
}

function OpenProfileLink() {
  const { key } = useParams();
  const decodedKey = useMemo(() => decodeURIComponent(key || "").trim(), [key]);
  const [showFallback, setShowFallback] = useState(false);

  const appUrl = useMemo(
    () => `${APP_SCHEME}/${encodeURIComponent(decodedKey)}`,
    [decodedKey]
  );

  useEffect(() => {
    const validKey = isValidKey(decodedKey);

    if (!decodedKey || !validKey) {
      setShowFallback(true);
      return;
    }

    const timer = window.setTimeout(() => {
      setShowFallback(true);
    }, FALLBACK_DELAY_MS);

    window.location.href = appUrl;

    return () => window.clearTimeout(timer);
  }, [decodedKey, appUrl]);

  const isInvalidKey = !decodedKey || !isValidKey(decodedKey);

  return (
    <main className="open-profile-page">
      <section className="open-profile-card">
        {!showFallback && (
          <>
            <h1 className="open-profile-title">Opening Lutero...</h1>
            <p className="open-profile-text">Redirecting you to chat on Lutero.</p>
          </>
        )}

        {showFallback && isInvalidKey && (
          <>
            <h1 className="open-profile-title">User does not exist</h1>
            <p className="open-profile-text">
              This chat link is invalid or no longer available.
            </p>
            <p className="open-profile-text">
              Chat with them on Lutero using a valid link.
            </p>
            <Link to="/" className="open-profile-link">Go to Lutero</Link>
          </>
        )}

        {showFallback && !isInvalidKey && (
          <>
            <h1 className="open-profile-title">Chat with this user on Lutero</h1>
            <p className="open-profile-text">
              If you already have the app, open this link in Lutero.
            </p>
            <p className="open-profile-text">
              If you don’t have the app yet, install it to start chatting.
            </p>

            <div className="open-profile-actions">
              <a href={appUrl} className="open-profile-button open-profile-button-primary">Open in app</a>
              <a href="/" className="open-profile-button open-profile-button-secondary">Install Lutero</a>
            </div>

            <p>
              <Link to="/" className="open-profile-link">Back to home</Link>
            </p>
          </>
        )}
      </section>
    </main>
  );
}

export default OpenProfileLink;